/*
 * Theme integration for Zapiet - Store Pickup + Delivery.
 * Zapiet's own files (snippets/storepickup*.liquid, assets/storepickup.js) are managed by
 * the app and must not be edited; this file holds the theme's side of the integration.
 */
(function () {
  /*
   * Restart the Zapiet widget after an AJAX cart change, first refreshing the product
   * tag/collection data it uses for its eligibility rules. See snippets/zapiet-cart-products.liquid.
   * When more than one data node exists (cart page also renders the drawer), the last one in
   * the document is the one inside the section that was just re-rendered.
   */
  window.zapietRefresh = function () {
    if (!window.Zapiet || !window.ZapietCachedSettings) return;
    var nodes = document.querySelectorAll('script[data-zapiet-products]');
    var node = nodes[nodes.length - 1];
    if (node) {
      try {
        ZapietCachedSettings.products = JSON.parse(node.textContent);
      } catch (e) {
        console.warn('Zapiet: could not parse cart product data', e);
      }
    }
    Zapiet.start(ZapietCachedSettings);
  };

  /*
   * Final gate before Zapiet submits the checkout form.
   * Every Zapiet.start() attaches a new document-level click handler bound to that widget
   * instance, and old handlers are never removed. An instance that was enabled earlier
   * (e.g. after choosing pickup) can therefore send the shopper to checkout even though the
   * widget currently on screen says checkout is not allowed. Zapiet calls
   * window.checkoutConditions when it is defined, so we check the live widget instance here.
   */
  window.checkoutConditions = function (button) {
    var app = document.getElementById('storePickupApp');
    var vm = app && app.__vue__;
    if (vm && vm.enable_app && !vm.checkout_enabled) {
      var translations = vm.translations && vm.translations[vm.selected_method];
      if (window.ZapietEvent && translations && translations.checkout_error) {
        ZapietEvent.fire('checkout_error', translations.checkout_error);
      }
      return false;
    }
    return Zapiet.Helpers.submitCheckout(button);
  };
})();
